module.exports = __webpack_public_path__ + "img/red-tmall.678bd041.gif";